import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// httpOnly cookie de sessão (`flua_session`) é enviado automaticamente pelo browser.
export const http = axios.create({ baseURL: API, withCredentials: true });

// Condominios
export const listCondominios = () => http.get("/condominios").then((r) => r.data);
export const createCondominio = (data) => http.post("/condominios", data).then((r) => r.data);
export const updateCondominio = (id, data) => http.put(`/condominios/${id}`, data).then((r) => r.data);
export const deleteCondominio = (id) => http.delete(`/condominios/${id}`).then((r) => r.data);
export const getCondominiosMapa = () => http.get("/condominios/mapa").then((r) => r.data);
export const setCondominioLocalizacao = (id, lat, lng, precisao = "manual") =>
  http.put(`/condominios/${id}/localizacao`, { lat, lng, precisao }).then((r) => r.data);
export const resetCondominioLocalizacao = (id) => http.delete(`/condominios/${id}/localizacao`).then((r) => r.data);
export const getCondominiosMetricasMensal = () =>
  http.get("/condominios/metricas-mensal").then((r) => r.data);

// Funil
export const listFunil = () => http.get("/funil").then((r) => r.data);
export const createFunil = (data) => http.post("/funil", data).then((r) => r.data);
export const updateFunil = (id, data) => http.put(`/funil/${id}`, data).then((r) => r.data);
export const deleteFunil = (id) => http.delete(`/funil/${id}`).then((r) => r.data);

// Atividades diárias do vendedor (relatório fino que alimenta o funil por dia/semana/mês)
export const listAtividades = () => http.get("/atividades-vendedor").then((r) => r.data);
export const createAtividade = (data) => http.post("/atividades-vendedor", data).then((r) => r.data);
export const updateAtividade = (id, data) => http.put(`/atividades-vendedor/${id}`, data).then((r) => r.data);
export const deleteAtividade = (id) => http.delete(`/atividades-vendedor/${id}`).then((r) => r.data);

// AI assistant — Claude Sonnet 4.6 via Emergent Universal Key
export const melhorarObservacao = (data) => http.post("/ai/melhorar-observacao", data).then((r) => r.data);

export const seedData = () => http.post("/seed").then((r) => r.data);

// Users (admin)
export const listUsers = () => http.get("/users").then((r) => r.data);
export const createUser = (data) => http.post("/users", data).then((r) => r.data);
export const updateUser = (id, data) => http.put(`/users/${id}`, data).then((r) => r.data);
export const deleteUser = (id) => http.delete(`/users/${id}`).then((r) => r.data);

// Vendedores (any user) — rota leve para lista de vendedoras + comissão
export const listVendedores = () => http.get("/vendedores").then((r) => r.data);

// Permissões (matriz de RBAC)
export const getPermissions = () => http.get("/permissions").then((r) => r.data);
export const updatePermissions = (data) => http.put("/permissions", data).then((r) => r.data);

// Enviar recibo por e-mail
export const sendReceipt = (vendedor_name, month) =>
  http.post("/reports/send-receipt", { vendedor_name, month }).then((r) => r.data);

// Prospectos
export const listProspectos = () => http.get("/prospectos").then((r) => r.data);
export const createProspecto = (data) => http.post("/prospectos", data).then((r) => r.data);
export const updateProspecto = (id, data) => http.put(`/prospectos/${id}`, data).then((r) => r.data);
export const deleteProspecto = (id) => http.delete(`/prospectos/${id}`).then((r) => r.data);

// Metas de prospecção
export const listMetasProspeccao = () => http.get("/metas-prospeccao").then((r) => r.data);
export const upsertMetaProspeccao = (vendedor, meta_mensal) =>
  http.post("/metas-prospeccao", { vendedor, meta_mensal }).then((r) => r.data);

// Clientes
export const listClientes = () => http.get("/clientes").then((r) => r.data);
export const createCliente = (data) => http.post("/clientes", data).then((r) => r.data);
export const updateCliente = (id, data) => http.put(`/clientes/${id}`, data).then((r) => r.data);
export const deleteCliente = (id) => http.delete(`/clientes/${id}`).then((r) => r.data);

// Onboarding pendentes (submissões do formulário público esperando aprovação)
export const listOnboardingPendentes = (status) =>
  http.get("/onboarding-pendentes", { params: status ? { status } : {} }).then((r) => r.data);
export const validarOnboardingPendente = (id) =>
  http.post(`/onboarding-pendentes/${id}/validar`).then((r) => r.data);
export const rejeitarOnboardingPendente = (id, motivo = "") =>
  http.post(`/onboarding-pendentes/${id}/rejeitar`, { motivo }).then((r) => r.data);
export const marcarOnboardingRespondido = (id) =>
  http.post(`/onboarding-pendentes/${id}/marcar-respondido`).then((r) => r.data);
export const getMetricasTempoResposta = (month) =>
  http.get("/onboarding-pendentes/metricas-resposta", { params: month ? { month } : {} }).then((r) => r.data);

// Ranking de vendedoras
export const getRankingVendedoras = (month) =>
  http.get("/ranking/vendedoras", { params: month ? { month } : {} }).then((r) => r.data);

// Onboarding apps (admin)
export const listOnboardingApps = () =>
  http.get("/config/onboarding-apps").then((r) => r.data);
export const createOnboardingApp = (data) =>
  http.post("/config/onboarding-apps", data).then((r) => r.data);
export const updateOnboardingApp = (id, data) =>
  http.put(`/config/onboarding-apps/${id}`, data).then((r) => r.data);
export const reorderOnboardingApps = (ids) =>
  http.post("/config/onboarding-apps/reorder", { ids }).then((r) => r.data);
export const deleteOnboardingApp = (id) =>
  http.delete(`/config/onboarding-apps/${id}`).then((r) => r.data);

// Metas por vendedor
export const listMetasVendedores = () => http.get("/metas-vendedores").then((r) => r.data);
export const listMetasMensais = () => http.get("/metas-mensais").then((r) => r.data);
// Aceita meta_mensal (R$), meta_clientes (int), bonus_pct (0..1 ou -1 para reset). Undefined preserva.
export const upsertMetaVendedor = (vendedor, patch) => {
  const body = { vendedor };
  // Compat: chamadas antigas passavam número — trata como meta_mensal.
  if (typeof patch === "number" || typeof patch === "string") {
    body.meta_mensal = Number(patch) || 0;
  } else if (patch && typeof patch === "object") {
    if (patch.meta_mensal !== undefined) body.meta_mensal = Number(patch.meta_mensal) || 0;
    if (patch.meta_clientes !== undefined) body.meta_clientes = Number(patch.meta_clientes) || 0;
    if (patch.bonus_pct !== undefined) body.bonus_pct = Number(patch.bonus_pct);
  }
  return http.post("/metas-vendedores", body).then((r) => r.data);
};

// Meta global do time
export const getMetaGlobal = () => http.get("/metas-globais").then((r) => r.data);
export const upsertMetaGlobal = (patch) => http.post("/metas-globais", patch).then((r) => r.data);

// Config (planos e bônus)
export const getConfig = () => http.get("/config").then((r) => r.data);
export const updateConfig = (data) => http.put("/config", data).then((r) => r.data);
